export default "__VITE_ASSET__DltxQ2vw__"